import isMobile from "is-mobile";
import { focusHash, bindInPageLinks } from "@shopify/theme-a11y";
import { load } from "@shopify/theme-sections";
import { qs } from "@fluorescent/dom";

import HomeSectionModifiers from "@/lib/home-section-modifiers";
import storeAvailabilityDrawer from "@/lib/store-availability-drawer";
import modal from "@/lib/modal";
import { handleTab } from "@/lib/a11y";

import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";

// Import sections
import "@/sections";

document.addEventListener("DOMContentLoaded", () => {
  load("*");
});

focusHash();
bindInPageLinks();

// a11y tab handler
handleTab();

if (isMobile()) {
  document.documentElement.classList.add("is-mobile");
}

if (navigator.cookieEnabled) {
  document.documentElement.className =
    document.documentElement.className.replace(
      "supports-no-cookies",
      "supports-cookies"
    );
}

setTimeout(function () {
  document.body.classList.remove("preload");
}, 500);

if (document.body.classList.contains("template-index")) {
  HomeSectionModifiers(qs("#main", document));
}

// Product availabilty drawer
const availabilityDrawer = qs("[data-store-availability-drawer]", document);
if (availabilityDrawer) storeAvailabilityDrawer(availabilityDrawer);

// Setup modal
const modalElement = qs("[data-modal]", document);
if (modalElement) modal(modalElement);
